export const tenderingTransporterFeedbackMap = {
  tendering_expired_valid_offer: {
    title: 'Proposta expirada',
    message: (obj) => `A proposta ${obj.externalId} expirou, mas ainda pode ser aceita.`,
    styleFeedbackType: 'info',
  },
  tendering_expired_invalid_offer: {
    title: 'Proposta expirada',
    message: (obj) => `A proposta ${obj.externalId} expirou e não é mais válida.`,
    styleFeedbackType: 'info',
  },
  tendering_running_offer: {
    title: 'Chegou a sua vez',
    message: (obj) => `A proposta ${obj.externalId} está disponível.`,
    styleFeedbackType: 'info',
  },
  tendering_expired_offer: {
    title: 'Proposta expirada',
    message: (obj) => `A oferta da carga: ${obj.externalId} foi encerrada.`,
    styleFeedbackType: 'info',
  },
}
